export class InvalidEmailException extends Error {
    constructor(email: string) {
        super(`El email "${email}" no es válido.`);
    }

    getMessage = () :string => {
        return this.message.replace('Error: ', '')
    }
}